<template>
    <div>
        <v-card elevation="0">
            <v-card-subtitle>
                Clicking on the download icon at the end of each document row will start downloading. Pop-ups must be allowed for this browser to download.
            </v-card-subtitle>
            <v-card-text>
                <v-container v-if="loading" style="height: 350px;">
                    <v-row
                        class="fill-height"
                        align-content="center"
                        justify="center"
                    >
                        <v-col cols="8" class="text-subtitle-1 text-center">
                            <v-card elevation="0">
                                <span>
                                    Getting your file&#40;s&#41;...
                                </span><br /><br />
                                <v-progress-linear
                                    color="#189AB4"
                                    indeterminate
                                    rounded
                                    height="6"
                                ></v-progress-linear>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
                <v-row v-else>
                    <v-col md="5" v-if="dataExists">
                        <v-card elevation="0">
                            <v-simple-table>
                                <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">
                                            Year
                                        </th>
                                        <th class="text-left">
                                            File
                                        </th>
                                        <th class="text-center">
                                            Download
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="item in results"
                                        :key="item.year"
                                    >
                                    <td>{{ item.year }}</td>
                                    <td>{{ item.filename }}</td>
                                    <td class="text-center"><v-icon @click="downloadFile(item.filename, type)">mdi-download-box</v-icon></td>
                                    </tr>
                                </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </v-col>
                    <v-col md="7" v-else-if="!dataExists">
                        <v-card elevation="0">
                            <v-alert
                                outlined
                                type="warning"
                                prominent
                                border="left"
                            >
                                We cannot find your file&#40;s&#41; for this document type &#40;{{ type }}&#41;.<br />
                                If you believe you should have one, please contact Student Finance Service.
                            </v-alert>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
            :top="mobile"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
export default {
    props: {
        type: {
            required: true
        }
    },
    data(){
        return {
            host: location.hostname.toString(),
            loading: true,
            selectedItem: 1,
            results: [],
            dataExists: false,
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            mobile: false,
            mobileWidthMax: 760
        }
    },
    methods: {
        getUserData(){
            if(sessionStorage.getItem("sfs_asss")){
                var avatar = JSON.parse(sessionStorage.getItem("sfs_asss"));
                return avatar["emplid"]
            }else {
                var real = JSON.parse(sessionStorage.getItem("user"));
                return real["employeeNumber"];
            }
        },
        getDocumentList(){
            const that = this;
            let api= 'https://'+that.host+'/cgi-bin/sfs-portal-api/api.py?getdocuments&data={"emplid":"'+that.getUserData()+'"}';
            that.results = [];
            that.loading = true;
            fetch(api)
                .then(function(response){
                    return response.json();
                })
                .then(function (data) {
                    if(data.result.match(/ok/i)){
                        that.setSnackbar("Load Successful!", "green");
                        var array = data.data[that.type];
                        var keys = Object.keys(array);
                        if(keys.length > 0){
                            for(var i=keys.length-1;i>=0; i--){
                                for(var j=0;j<array[keys[i]].length; j++){
                                    that.results.push({
                                        "year" : keys[i],
                                        "filename" : array[keys[i]][j]
                                    });
                                }
                            }
                            that.loading = false;
                            that.dataExists = true;
                        }else {
                            that.loading = false;
                            that.dataExists = false;
                        }
                    }else {
                        that.setSnackbar("Warning: "+data.message.toString(), "orange");
                        that.loading = false;
                        that.dataExists = false;
                    }
                })
                .catch(function (err) {
                    that.setSnackbar("Error occurred : "+err.toString(), "red");
                    that.loading = false;
                    that.dataExists = false;
                })
        },
        downloadFile(filename, type){
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/sfs-portal-api/api.py?download&data={ "emplid" : "'+that.getUserData()+'", "file" : "'+filename+'", "type" : "'+type+'" }';

            fetch(api, {
                method: 'POST'
            })
            .then(function(response){
                return response;
            })
            .then(function(data){

                //response.status == 404 / success
                window.open(api);
            })
            .catch(function (err) {
                that.setSnackbar("Error occurred : "+err.toString(), "red");
            });
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;

            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        },
        onResize() {
            const that = this;
            window.addEventListener("resize", () => {
                that.detectUX();
            });
        },
        detectUX() {                
            const that = this;
            that.mobile = window.innerWidth <= that.mobileWidthMax ? true : false;
        } 
    },
    created(){
        const that= this;
        that.getDocumentList();
    },
    mounted() {      
      this.detectUX();
      this.onResize();      
    }
}
</script>
<style scoped>
tbody > tr:nth-child(odd){
    background-color: #E0F7FA;
}
tbody > tr:nth-child(even){
    background-color: white;
}
</style>
